import stringToNumber from "src/utils/stringToNumber";
import { SalesTableData, SalesTableInitialState } from "../interface";
import { sorter } from "src/utils/sorter";

export const initialState: SalesTableInitialState = {
  data: [],
  recordsCount: null,
  status: "idle",
  error: null,
  totalUnitsSold: 0
};

export const calculateTotalUnitsAndAverageCasesReceived = (
  data: SalesTableData[]
) => {
  let totalUnitsSold = 0;
  // Take weekly avg value of total cases received
  const salesDataWithAvgCasesReceived = data.map(
    (weeklySales: SalesTableData) => {
      totalUnitsSold += stringToNumber(weeklySales.totalUnits);
      return {
        ...weeklySales
      };
    }
  );

  sorter(salesDataWithAvgCasesReceived, "weekEnded", "DESC");
  return {
    salesDataWithAvgCasesReceived,
    totalUnitsSold: totalUnitsSold.toFixed(totalUnitsSold > 0 ? 2 : 0)
  };
};
